import { defineStore } from 'pinia';

type StoreStateType = {
	mobileDevice?: string;
	appVersion?: string;
};
export const useMobileDeviceStore = defineStore('mobileDevice', {
	state: (): StoreStateType => {
		return {
			mobileDevice: '',
			appVersion: '',
		};
	},
	getters: {
		getMobileDevice(state) {
			return state.mobileDevice;
		},
		getAppVersion(state) {
			return state.appVersion ?? '';
		},
	},
	actions: {
		setMobileDevice(mobileDevice: string) {
			this.mobileDevice = mobileDevice;
		},
		setAppVersion(appVersion: string) {
			this.appVersion = appVersion;
		},
		resetAuth() {
			this.$reset();
		},
	},
	persist: true,
});
